
const BOOK_SEARCH_TEMPLATE = `
	<div id="searchBar" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p0">
	<input type="text" name="search" placeholder="<%= app.localeManager.get('searchbar.search') %>" class="px-15"/></div>
	<div class="clearfix"></div>
`;
const SearchBarComponent = Backbone.View.extend({
	events: {
		"click #submitSearch": "update",
		"click #closeSearch": "close",
		"click #searchResults div.bookContainer": "close",
		"click #clearSearch": "reset"
	},
	render: function render() {
		this.$el.html(this.template());
		return this;
	},
	id: "searchWrapper",
	template: _.template(BOOK_SEARCH_TEMPLATE),
	// Close the search bar
	// Hide the search bar icons
	close: function close() {
		this.$el.fadeOut("fast");
	},
	open: function open() {
		this.$el.animateCssIn("bounceInDown");
	},
	// Reset the search bar with no value
	reset: function reset() {
		this.$el.find("input[name=search]").val("");
		$("#searchResults").empty();
		return this;
	},
	// Update the books based on what the user has entered
	// Will filter through every relevent book's properties (title, authors, theme, year and country)
	// and return a limited amount of books
	submitSearch: function submitSearch() {
		app.router.navigate("#" + app.getLanguage() + "/search/" + this.$el.find("input[name=search]").val(), {
			trigger: true,
			replace: true
		});
		this.close();
	}
});